import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/review/")({
  beforeLoad: () => {
    throw redirect({ href: "/admin/offers" });
  },
});
